<template>
    <div id="view-model">
        <div class="cheader-viewmodel">
            <div class="hpBanner-loge">
                <router-link class="hpBanner-pointer" :to="{ path: '/' }" tag="div"></router-link>
                <embed class="hpBanner-img" :src="`${$baseUrl}dataMock/homePage/pkpmLogo.png`" />

                <!-- <h1 ></h1> -->
                <h1 class="hpBanner-ctx">丨{{ '模型浏览 — ' + titleName }}</h1>
                <!-- <router-link :to="{path: '/devcenter'}"  class="hpBanner-ctx" tag="h1">丨{{headerTile}}</router-link> -->
            </div>
            <div class="download-container" v-if="isShowDownload">
                <div class="icon-item" title="下载">
                    <el-button type="text" @click="toDownload" :disabled="isDownloadDisabled">
                        <i class="el-icon-download download-icon"></i>
                    </el-button>
                </div>
                <div class="progress-item" v-if="isShowProgress">
                    <el-progress
                        :stroke-width="3"
                        :width="36"
                        :show-text="false"
                        color="#67C23A"
                        type="dashboard"
                        :percentage="downloadPercentage"
                    ></el-progress>
                </div>
            </div>
        </div>
        <ViewModel
            v-if="modelOptions.length"
            :isShow2d="true"
            :configAddin="[
                {
                    id: 'OBVAddins.Marker',
                    noButton: false,
                    unRepeatMarkerPos: false,
                    enableMarkerMove: true,
                },
            ]"
            :viewModelItem="modelOptions"
            :getAccessToken="getAccessToken"
            @bimbox-viewer="obvViewerApi"
        ></ViewModel>
        <el-dialog title="分享密码" :visible.sync="codeDialog" :close-on-click-modal="false" width="30%">
            <el-input v-model="inputCode" placeholder="请输入密码"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="vertifiedCode">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import axios from 'axios';
import { getShareViewToken } from 'src/utils/modelUtils';
import { getShareMess } from 'src/utils/shareUtils';
import { analysisFileType } from '../../utils/commonUtils';
import { getJobType, getConverterTypes } from '../../utils/jobUtils';
import { getObjectsDownUrl } from 'src/utils/modelUtils';

export default {
    components: {},
    name: 'shareView',
    props: {
        showToolBar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            shareInfo: null,
            modelOptions: [],
            token: '',
            convertObj: '',
            obvApi: undefined,
            showViewer: false,
            modelsData: [],
            modelName: '', // 模型名称
            viewName: '', // 视图名称
            viewModelStatus: false,
            codeDialog: false,
            inputCode: '',
            isShow: false,
            downloadPercentage: 0,
            fileTypes: null,
        };
    },
    computed: {
        titleName() {
            return this.modelName + `${this.viewName ? `-${this.viewName}` : ''}`;
        },
        isShowDownload() {
            // return this.shareInfo && this.shareInfo.isView;
            return false;
        },
        isShowProgress() {
            // return this.shareInfo && this.shareInfo.isView && this.isShow;
            return false;
        },
        isDownloadDisabled() {
            return this.downloadPercentage > 0 && this.downloadPercentage < 100;
        },
    },
    methods: {
        uninitializeViewer(obvApi) {
            if (obvApi) {
                obvApi.uninitializeViewer();
            }
        },
        obvViewerApi(obvApi) {
            this.obvApi = obvApi;
        },
        getAccessToken(cb) {
            // todo
            let data = {
                shareId: this.$route.params.shareId,
                password: this.inputCode,
            };
            getShareViewToken(data).then((res) => {
                cb(res.data.newToken, 60000);
            });
        },
        // 获取不同格式对应的jobType(除dwg2d)
        getJobType(fileFormat, convertWay) {
            if (fileFormat === 'dwg') {
                // return `dwg3d-${convertWay}`;
                return `dwg-${convertWay}`;
            } else {
                let tempConverters = this.fileTypes[fileFormat].converters;
                for (let index = 0; index < tempConverters.length; index++) {
                    let tempType = tempConverters[index].name.split('-');
                    if (tempType[tempType.length - 1] === convertWay) {
                        return tempConverters[index].name;
                    }
                }
            }
        },
        // 分享模型加载初始化
        shareModel(shareInfo) {
            /*
             * 按type类型区分模型
             * 0 模型视图
             * 1 模型文件
             * 2 模型组装
             * 3 未研发完成
             * 4 LOD模型
             * 5 LOD组装
             * */
            switch (shareInfo.type) {
                case 0: // 模型视图分享
                    const modelData = JSON.parse(shareInfo.conf);
                    const guid = modelData.guid || modelData;
                    this.viewName = modelData.viewName || modelData;
                    this.loadSingleModel(shareInfo, guid);
                    break;
                case 1:
                case 4: // 无视图模型分享（默认第一个视图）
                    this.loadSingleModel(shareInfo, '');
                    break;
                case 2:
                case 5: // 模型组装分享
                    const modelLoadingObject = JSON.parse(shareInfo.conf);
                    const modelObject = modelLoadingObject.modelViewsOptions;
                    this.loadAssembleModel(modelObject, shareInfo.mode);
                    break;
                default:
                    this.$message.error('无效的分享！');
                    break;
            }
        },
        // 加载单个模型
        loadSingleModel(shareInfo, guid) {
            let shareMess = [];
            shareMess.push({
                fileName: shareInfo.id,
                shareId: this.$route.params.shareId,
                shareUrn: shareInfo.urn,
            });
            const urn = shareMess[0].shareUrn;
            // 使用mode区分obv和lod，1为lod
            let shareModelJobType = shareInfo.mode === 1 ? 'lod' : 'obv';
            getJobType(analysisFileType(urn), shareModelJobType).then((jobRes) => {
                this.modelOptions.push({
                    documentUrn: urn,
                    guid: guid,
                    converterType: jobRes,
                });
            });
        },
        // 加载模型组装
        loadAssembleModel(modelObject, mode) {
            // 使用mode区分obv和lod，1为lod
            let shareModelJobType = mode === 1 ? 'lod' : 'obv';
            getConverterTypes().then((jobRes) => {
                this.fileTypes = jobRes.filetypes;
                modelObject.forEach((item) => {
                    const options = {
                        documentUrn: item.documentUrn,
                        guid: item.guid,
                        packageParams: item.offset,
                        converterType: this.getJobType(analysisFileType(item.documentUrn), shareModelJobType),
                    };
                    this.modelOptions.push(options);
                });
            });
        },
        // 验证密码
        vertifiedCode() {
            let _self = this;
            let data = {
                shareId: this.$route.params.shareId,
                password: this.inputCode,
            };
            getShareMess(data)
                .then((res) => {
                    _self.shareInfo = res.data;
                    _self.modelName = res.data.name;
                    _self.shareModel(_self.shareInfo);
                    _self.viewModelStatus = true;
                    _self.codeDialog = false;
                })
                .catch((err) => {
                    _self.$message.error('您输入的密码有误，请重新输入');
                });
        },
        // 点击下载按钮
        toDownload() {
            this.isShow = true;
            const tempArray = this.shareInfo.urn.slice(18).split('/');
            const tempInfo = {
                bucketKey: tempArray[0],
                fileName: tempArray[1],
            };
            getObjectsDownUrl(tempInfo.bucketKey, tempInfo.fileName).then((res) => {
                let _self = this;

                // 下载
                function download(url, filename) {
                    _self.getBlob(url, function (blob) {
                        _self.saveAs(blob, filename);
                    });
                }

                let URL = res.url;
                let fileLength = tempInfo.fileName.lastIndexOf('_');
                let type = tempInfo.fileName.substring(fileLength + 1, tempInfo.fileName.length);
                let modelDownloadName = tempInfo.fileName.substring(0, fileLength);
                download(URL, modelDownloadName + '.' + type);
            });
        },
        // 获取下载进度
        getBlob(url, cb) {
            let _self = this;
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            };
            xhr.onprogress = function (e) {
                // e.loaded代表上传了多少
                // e.total代表总数为多少
                _self.downloadPercentage = parseFloat(((e.loaded / e.total) * 100).toFixed(0));
            };
            xhr.send();
        },
        // 下载文件
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                let link = document.createElement('a');
                let body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                // fix Firefox
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
    },
    async created() {
        const query = this.$route.params;
        this.modelOptions = [];
        let data = {
            shareId: query.shareId,
        };
        getShareMess(data)
            .then((res) => {
                this.shareInfo = res.data;
                this.modelName = this.shareInfo.name;
                this.shareModel(this.shareInfo);
                this.viewModelStatus = true;
            })
            .catch((err) => {
                // 增加了err.responseJSON的判定
                if (err.responseJSON && err.responseJSON.code === '404') {
                    this.$router.push({ path: `/devcenter/shareModelView/modelMissShare` });
                } else if (err.responseJSON && err.responseJSON.code === 'CONSOLE.SHARE_EXPIRED') {
                    this.$router.push({ path: `/devcenter/shareModelView/modelCancelShare` });
                } else if (err.responseJSON) {
                    this.codeDialog = true;
                }
            });
    },
    destroyed() {
        if (obvApi) {
            obvApi.uninitializeViewer();
        }
    },
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
#view-model
  position absolute
  height 100%
  width 100%

  .cheader-viewmodel
    width 100%
    height 60px
    background-color $background-blue

    .hpBanner-loge
      z-index 1
      position absolute
      left 5.3%
      top 12px
      display flex
      align-items center

      .hpBanner-pointer
        z-index 1
        cursor pointer
        background-color transparent
        position absolute
        width 120px
        height 26px

      .hpBanner-img
        position relative
        width 120px
        height 26px

      .hpBanner-ctx
        width auto
        height 36px
        color $font-white
        font-size $font-size-logo
        font-weight bold
        line-height 36px

    .download-container
      position absolute
      right 5.3%
      top 12px

      .icon-item
        width 36px
        z-index 1
        position absolute
        text-align center

        .el-button
          padding 0
          border 0
          color $font-white

          &:hover
            color rgba(32, 160, 255, 1)

        .download-icon
          height 36px
          line-height 36px
          font-size 22px
          font-weight bold

      .progress-item
        height 36px
        position absolute

  #obv-wrapper
    position relative
    width 100%
    height calc(100% - 60px)
    background #161616

/* .bimbox-toolbar
display:none!important */
</style>



// WEBPACK FOOTER //
// src/pages/ShareView/ShareView.vue